import React, { useState, useEffect } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { path: "#about", label: "About Us" },
    { path: "#amenities", label: "Amenities" },
    { path: "#gallery", label: "Gallery" },
    { path: "#rooms", label: "Choice Of Rooms" },
    { path: "#contact", label: "Booking" },
  ];

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav
      className={`navbar ${scrolled ? "navbar--scrolled" : ""} ${
        menuOpen ? "navbar--open" : ""
      }`}
    >
      <div className="navbar__inner">
        <a href="#home" className="navbar__logo" onClick={handleNavClick}>
          <img
            src="/images/logo.png"
            alt="CozyRooms Logo"
            className="navbar__logo-img"
          />
        </a>

        <ul className="navbar__links">
          {navLinks.map((link) => (
            <li key={link.path}>
              <a
                href={link.path}
                className="navbar__link"
                onClick={handleNavClick}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className={`navbar__hamburger ${
            menuOpen ? "navbar__hamburger--open" : ""
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div
        className={`navbar__mobile-menu ${
          menuOpen ? "navbar__mobile-menu--open" : ""
        }`}
      >
        <ul>
          {navLinks.map((link) => (
            <li key={link.path}>
              <a
                href={link.path}
                className="navbar__mobile-link"
                onClick={handleNavClick}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;